<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Doc — Ação: Ciência
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Como registrar
        strong  ciência
        |  em um documento (ex.: após publicação em diário oficial ou entrega).

      .toast.toast-primary
        | Exige a permissão
        strong  Fiscalização → Documentos → Ciência
        | .

      h5.h5 1. Abrir a ação
      ol
        li Abra o documento (
          strong Doc → Documentos → Exibir
          | ).
        li No rodapé, abra o menu
          strong  Ações
          | .
        li Clique na opção desejada (Ciência).
      figure.manual-figure
        img(:src="imgMenu" alt="Menu Ações do documento")

      h5.h5 2. Modal Ciência
      figure.manual-figure
        img(:src="imgModal" alt="Modal Ciência do documento")
      ol
        li Informe a data/hora e demais campos solicitados.
        li Confirme para registrar a ciência.
      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgMenu: require("@/assets/manuais/14-doc-acoes-menu.png"),
      imgModal: require("@/assets/manuais/14d-doc-acao-ciencia.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
